import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { EmergencyMedicationsRedux } from '../Redux/EmergencyMedications'

const EmergencyMedicationsCRUDObservable = createCRUDObservable({
  mainRedux: EmergencyMedicationsRedux,
  reduxPath: 'emergencyMedications',
})

export const EmergencyMedicationsObservers = Object.assign({},
  EmergencyMedicationsCRUDObservable.observers, {
  })

export const EmergencyMedicationsEpic = combineEpics(
  EmergencyMedicationsCRUDObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/EmergencyMedicationsObservable.js